"use strict";
exports.__esModule = true;
exports.RecordStepPermission = exports.Permission = void 0;
var Permission;
(function (Permission) {
    Permission["surveyCreate"] = "surveyCreate";
    Permission["surveyEdit"] = "surveyEdit";
    Permission["recordCreate"] = "recordCreate";
    Permission["recordEdit"] = "recordEdit";
    Permission["recordView"] = "recordView";
    Permission["recordCleanse"] = "recordCleanse";
    Permission["recordAnalyse"] = "recordAnalyse";
    Permission["userEdit"] = "userEdit";
    Permission["userInvite"] = "userInvite";
    Permission["permissionsEdit"] = "permissionsEdit";
})(Permission = exports.Permission || (exports.Permission = {}));
var RecordStepPermission;
(function (RecordStepPermission) {
    RecordStepPermission["all"] = "all";
    RecordStepPermission["own"] = "own";
})(RecordStepPermission = exports.RecordStepPermission || (exports.RecordStepPermission = {}));
//# sourceMappingURL=permission.js.map